import * as React from "react";

import { concatStyleSets } from "@fluentui/react";

import { AppComboBox, AppComboBoxInternalProps } from "@1js/acui-combobox";
import { getModernUxExperimentPreference } from "@1js/acui-common";
import { AppContext } from "@1js/acui-context";
import { MeasuredContext } from "@1js/acui-resize-group";
import { shouldShadowRender } from "@1js/acui-shadow-rendering";

import { getModernUxRibbonComboBoxStyles } from "../../../../styling";
import { RibbonControlInternalProps } from "../RibbonControlProps";

export type RibbonComboBoxInternalProps = AppComboBoxInternalProps &
  RibbonControlInternalProps;

export class RibbonComboBox extends React.PureComponent<
  RibbonComboBoxInternalProps,
  {}
> {
  public render() {
    const { shadowRenderMenu } = this.props;
    const styles = getModernUxExperimentPreference()
      ? concatStyleSets(
          this.props.styles,
          getModernUxRibbonComboBoxStyles(this.props.id)
        )
      : this.props.styles;
    return (
      <MeasuredContext.Consumer>
        {({ isMeasured }) => (
          <AppContext.Consumer>
            {(context) => (
              <AppComboBox
                {...this.props}
                styles={styles}
                dataAutomationType="RibbonComboBox"
                persistMenu={true}
                optionStyles={this.props.optionStyles}
                shadowRenderMenu={shouldShadowRender(
                  shadowRenderMenu,
                  context,
                  isMeasured
                )}
                preventCalloutDismissOnScroll={true}
              />
            )}
          </AppContext.Consumer>
        )}
      </MeasuredContext.Consumer>
    );
  }
}
